import { Link } from "react-router-dom";
import chatImg from "../assets/img/chat.svg";
import chatbotImg from "../assets/img/chatbot.svg";
import logo from "../assets/img/trini_logo_horizontal.svg";
import AlertMsg from "../components/info/AlertMsg";
import { EmailIcon, LockIcon, UserIcon } from "../components/Icons";
import useAuth from "../hooks/useAuth";

function Login() {
  document.title = "Iniciar Sesión | Trini Talkbot";

  const {
    page,
    dataLogin,
    dataRegister,
    errorMsg,
    changeLoginPage,
    handleSubmitLogin,
    handleChangeLogin,
    handleSubmitRegister,
    handleChangeRegister,
  } = useAuth();

  return (
    <>
      <div className={page === 1 ? "container" : "container sign-up-mode"}>
        <div className="forms-container">
          <div className="signin-signup">
            <form onSubmit={handleSubmitLogin} className="sign-in-form">
              <h2 className="titleLogin">Iniciar Sesión</h2>
              <div>
                {errorMsg && <AlertMsg type="danger" text={errorMsg} />}
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="text"
                  placeholder="Ingresa tu usuario.."
                  id="username"
                  name="username"
                  onChange={handleChangeLogin}
                  value={dataLogin.username}
                  maxLength={40}
                  autoFocus
                />
              </div>

              <div className="input-field">
                <LockIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Ingresa tu contraseña.."
                  id="password"
                  name="password"
                  onChange={handleChangeLogin}
                  autoComplete="on"
                  value={dataLogin.password}
                  maxLength={60}
                />
              </div>

              <button type="submit" className="btnlogin solid">
                Ingresar
              </button>
              <div>
                <Link to="/login/reset" className="linkTo">
                  ¿Has olvidado tu contraseña?
                </Link>
              </div>
            </form>
            <form onSubmit={handleSubmitRegister} className="sign-up-form">
              <h2 className="titleLogin">Registrarse</h2>
              <div>
                {errorMsg && <AlertMsg type="danger" text={errorMsg} />}
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="text"
                  placeholder="Ingresa tu nombre.."
                  id="nameregister"
                  name="name"
                  onChange={handleChangeRegister}
                  value={dataRegister.name}
                  autoComplete="off"
                  maxLength={70}
                />
              </div>
              <div className="input-field">
                <UserIcon color="#212529" />
                <input
                  type="text"
                  placeholder="Ingresa un nombre de usuario.."
                  id="usernameregister"
                  name="username"
                  onChange={handleChangeRegister}
                  value={dataRegister.username}
                  autoComplete="off"
                  maxLength={40}
                />
              </div>
              <div className="input-field">
                <EmailIcon size="24px" color="#212529" />
                <input
                  type="email"
                  placeholder="Ingresa tu correo electrónico.."
                  id="email"
                  name="email"
                  onChange={handleChangeRegister}
                  value={dataRegister.email}
                  autoComplete="off"
                  maxLength={150}
                />
              </div>
              <div className="input-field">
                <LockIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Ingresa una contraseña.."
                  id="passwordregister"
                  name="password"
                  onChange={handleChangeRegister}
                  value={dataRegister.password}
                  autoComplete="off"
                  maxLength={60}
                />
              </div>
              <div className="input-field">
                <LockIcon color="#212529" />
                <input
                  type="password"
                  placeholder="Repite la contraseña.."
                  id="password2"
                  name="password2"
                  onChange={handleChangeRegister}
                  value={dataRegister.password2}
                  autoComplete="off"
                  maxLength={60}
                />
              </div>
              <button type="submit" className="btnlogin">
                Registrarme
              </button>
            </form>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <img
                src={logo}
                alt="trini logo"
                className="imageLogo"
                onClick={() => {
                  location.href = "https://trinitalkbot.com/";
                }}
                style={{ cursor: "pointer" }}
              />
              <p className="loginSub">
                ¡Únete a nosotros y comienza a disfrutar de una experiencia
                excepcional!
              </p>
              <button
                className="btnlogin transparent"
                id="sign-up-btn"
                onClick={() => changeLoginPage(2)}
              >
                Registrarse
              </button>
            </div>
            <img src={chatImg} className="image" alt="Chatbot image" />
          </div>
          <div className="panel right-panel">
            <div className="content">
              <img
                src={logo}
                alt="trini logo"
                className="imageLogo"
                onClick={() => {
                  location.href = "https://trinitalkbot.com/";
                }}
                style={{ cursor: "pointer" }}
              />
              <p className="loginSub">
                ¿Ya tienes una cuenta? Ingresa haciendo clic aquí.
              </p>
              <button
                className="btnlogin transparent"
                id="sign-in-btn"
                onClick={() => changeLoginPage(1)}
              >
                Ingresar
              </button>
            </div>
            <img src={chatbotImg} className="image" alt="chatbot image" />
          </div>
        </div>
      </div>
      <div className="row footerLogin">
        <div className="col-md-6">
          {new Date().getFullYear()} - TRINI Talkbot ® - Chatbot con
          Inteligencia Artificial
        </div>
        <div className="col-md-6 d-flex justify-content-end">
          <Link className="linkFooter" to="/tyc">
            Términos y Condiciones de Uso
          </Link>
        </div>
      </div>
    </>
  );
}

export default Login;
